<template>
  <div>
    <l-editor v-if="data.type == 'texteditor'" v-model="value2" :options="{ theme:'snow',placeholder: $t('请输入内容...')}"  >
    </l-editor>
    <component v-else :is="getComponent(data.type)"
               v-model="value2"
               v-bind="data"
               :placeholder="$t(data.placeholder)"
               :options="myOptions"

               :size="data.subfield ? 'mini':data.size"
               :activeValue="toValueType(data.valueType,data.activeValue)"
               :inactiveValue="toValueType(data.valueType,data.inactiveValue)"

               :disabled="tableRowDisabled"

               @change="handleChange"
               >
        <span v-if="data.html"
            v-html="data.html"></span>
        <template v-if="['input'].includes(data.type) && data.prepend" #prepend >
            {{data.prepend}}
        </template>
        <template v-if="['input'].includes(data.type) && data.append" #append >
            {{data.append}}
        </template>
    </component>
  </div>
</template>
<script>
import mixin from '../../mixin'
export default {
    name: 'viewer-form-item',
    mixins: [mixin()],
    props: {
        value:{},
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        row:{
            type: Object,
            default: () => {
                return {}
            }
        },
        formData:{
            type: Object,
            default: () => {
                return {}
            }
        },

        isForm:{// 是否表单里的对象，用来区分对查询框的操作
            type:Boolean,
            default:false
        },
        formInfo:{
            type:Object,
            default:()=>{
                return {};
            }
        },
        components:{
            type:Object,
            default:()=>{
                return {};
            }
        },
        setRequired:Function,
        setDisabled:Function,
        getShowText:Function,
        changeDataEvent:String,

    },
    data() {
        return {
            dataItemList:[],
            dataSourceList:[],
        }
    },
    computed:{
        value2:{
            get(){
                return this.value;
            },
            set(val){
                 this.$emit('input', val);
            }
        },
        nextDataCodes() {//获取所有下级主键
            if (this.components) {
                const res = []
                for (const key in this.components) {
                    const compant = this.components[key]
                    if (compant.upCtrl == this.data.prop && res.indexOf(compant.dataCode) == -1) {
                        res.push(compant.dataCode)
                    }
                }
                return res
            } else {
                return []
            }
        },

        tableRowDisabled(){
            if(this.data.subfield){
                const abledList = this.row.abledList || []
                if(this.row.disabled && abledList.indexOf(this.data.prop) == -1 ){
                    return true
                }
            }
            return this.data.disabled
        }
    },
    watch:{
        dataCode(){
            this.loadOptions()
        },
        dataType(){
            this.loadOptions()
        }
    },
    methods: {
        toValueType(type,value){
            if(!this.$validatenull(value) && !this.$validatenull(type)){
                switch(type){
                    case 'boolean':
                        return value == 'true';
                    case 'string':
                        return value;
                    case 'number':
                        return Number(value);
                }
            }
        },
        handleChange(changeData){
            // 脚本
            if(this.isForm){
                const {res,fn} = this.$getFunction(this.data.changeCode)
                if(res){
                    fn({data:changeData,formData:this.$deepClone(this.formData),setFormData:this.setFormData,setRequired:this.setRequired,setDisabled:this.setDisabled}) // 没有选中就是 undefined
                }

                // 值改变事件
                const res2  = this.$getFunction(this.changeDataEvent)
                if(res2.res){
                    res2.fn({formData:this.$deepClone(this.formData),setFormData:this.setFormData,getShowText:this.getShowText})
                }
            }

            // 子表单
            if(this.data.subfield){
                // 值改变事件
                const res3  = this.$getFunction(this.changeDataEvent)
                if(res3.res){
                    res3.fn({row:this.$deepClone(this.row),formData:this.$deepClone(this.formData),setRowData:this.setRowData,getShowText:(id)=>{ return this.getShowText(id,this.row)}})
                }
            }

            //根据右侧赋值字段给表单赋值地图信息
            if (this.data.type == "layerbmap") {
                if (this.data.bindaddr) {
                    if(changeData){
                        this.$set(this.formData, this.data.bindaddr, changeData.address); //设置绑定地址
                    }
                    else{
                        this.$set(this.formData, this.data.bindaddr, ''); //设置绑定地址
                    }
                }
                if (this.data.bindaddrpoint) {
                    if(changeData){
                        this.$set(this.formData,this.data.bindaddrpoint,`${changeData.lng},${changeData.lat}`);//设置绑定经纬度
                    }
                    else{
                        this.$set(this.formData, this.data.bindaddrpoint, ''); //设置绑定地址
                    }
                    
                }
            }

            if(this.data.type == 'layerselect'){
                if(!this.data.subfield){
                    this.data.columns.forEach(col=>{
                        if(col.valueKey){
                            if(changeData){
                                this.$set(this.formData,col.valueKey,changeData[col.prop])
                            }
                            else{
                                this.$set(this.formData,col.valueKey,undefined)
                            }
                            
                        }
                    })
                }
                else{
                    this.data.columns.forEach(col=>{
                        if(col.valueKey){
                            if(changeData){
                                this.$set(this.row,col.valueKey,changeData[col.prop])
                            }
                            else{
                                this.$set(this.row,col.valueKey,undefined)
                            }
                            
                        }
                    })
                }
            }

            if(this.lr_loadDataSourceDataByParamter && ["select","layerselect"].includes(this.data.type)){
                if(this.nextDataCodes.length > 0){
                    this.clearSubValue(this.data.prop)
                }
                this.nextDataCodes.forEach((dataCode) => {
                    if(changeData){
                        this.lr_loadDataSourceDataByParamter(dataCode, changeData.value)
                    }
                })
            }
        },
        clearSubValue(upProp) {
            for (let key in this.components) {
                const compant = this.components[key]
                if (compant.upCtrl == upProp) {
                    this.setFormData('', compant.prop)
                    this.clearSubValue(compant.prop)
                }
            }
        },
        setFormData(v,prop,type){
            switch(type){
                case 'addTable':
                    this.addTableData(v,prop)
                    break
                case 'deleteTable':
                    this.deleteTableData(v,prop)
                    break
                case 'updateTable':{
                        const propList = prop.split(',')
                        const tableProp = propList[0]
                        const index = propList[1]
                        const prop2 = propList[2]
                        this.updateTableData(v,tableProp,index,prop2)
                    }
                    break
                default:
                    this.$set(this.formData,prop,v)
                    break
            }
            
        },
        setRowData(v,prop,type){
            switch(type){
                case 'addTable':
                    this.addTableData(v,prop)
                    break
                case 'deleteTable':
                    this.deleteTableData(v,prop)
                    break
                case 'updateTable':{
                        const propList = prop.split(',')
                        const tableProp = propList[0]
                        const index = propList[1]
                        const prop2 = propList[2]
                        this.updateTableData(v,tableProp,index,prop2)
                    }
                    break
                default:
                    this.$set(this.row,prop,v)
                    break
            }
        },

        addTableData(row,prop){
            this.formData[prop].push(row)
        },
        deleteTableData(index,prop){
            this.formData[prop].splice(index,1)
        },
        updateTableData(v,tableProp,index,prop){
            const row = this.formData[tableProp][index]
            this.$set(row,prop,v)
        }
    }
}
</script>